import gql from 'graphql-tag'

export const GRUPO_FRAGMENT = gql`
  fragment GrupoFragment on Grupo {
    id
    nome
  }
`

export const GRUPOS_QUERY = gql`
  ${GRUPO_FRAGMENT}
  query GruposAtivos {
    gruposAtivos {
      ...GrupoFragment
    }
  }
`
